import React from 'react';
import { Link } from 'gatsby';

import { StaticImage } from 'gatsby-plugin-image';

const Hero = () => {
	return (
		<header className="hero">
			<section className="section-center hero-center">
				<article className="hero-info">
					<div>
						<h4 className="pre-title"> Hi there,</h4>
						<h1 className="main-title">
							I'm <br />Zrinka
						</h1>
						<div className="after-title">A Front-End Web Developer</div>
						<div className="hero-btns">
							<Link to="/contact" className="btn">
								Say hello
							</Link>
							<Link to="/about" className="btn-text">
								About me &#8594;
							</Link>
						</div>
					</div>
				</article>
				<div className="img-wrapper">
				<StaticImage src="../assets/images/profile-idea1.svg" 
        alt="portfolio"
        className="hero-img"
        placeholder="tracedSVG"
				/>
				</div>
			</section>
		</header>
	);
};

export default Hero;
